import { Box } from "@chakra-ui/react";
import SimpleIntro, { IntroProps } from "@/components/simpleIntro";

const IntroComponent = (props: IntroProps) => {
  return (
    <Box mb={16}>
      <SimpleIntro {...props} />
    </Box>
  );
};

export default IntroComponent;
